import { FC } from "react";
import MainNav1 from "./HostNav";
import ClientNav from "./ClientNav";

export interface HeaderProps {
  navType?: "ClientNav" | "HostNav" | "DefaultNav";
  className?: string;
}

const Header: FC<HeaderProps> = ({ navType = "DefaultNav", className = "" }) => {

  const renderNav = () => {
    switch (navType) {
      case "ClientNav":
        return <ClientNav />;
      default:
        // Default to MainNav1 which also works for HostNav
        return <MainNav1 />;
    }
  };

  return (
    <div
      className={`nc-Header sticky top-0 w-full left-0 right-0 z-40 nc-header-bg ${className}`}
    >
      {renderNav()}
    </div>
  );
};

export default Header;
